import PropTypes from "prop-types";

export const DateType = PropTypes.oneOfType([
  PropTypes.instanceOf(Date),
  PropTypes.string,
  PropTypes.number
]);

export const BulletType = PropTypes.arrayOf(PropTypes.string);

export const HighlightDateShape = PropTypes.shape({
  date: DateType.isRequired,
  bullets: BulletType,
  tooltip: PropTypes.any
});

export const HighlightDatesShape = PropTypes.shape({
  dates: PropTypes.arrayOf(PropTypes.oneOfType([DateType, HighlightDateShape]))
    .isRequired,
  bullets: BulletType,
  tooltip: PropTypes.any
});

export const HightlightDatesPropType = PropTypes.arrayOf(
  PropTypes.oneOfType([DateType, HighlightDateShape, HighlightDatesShape])
);

export const popperPlacements = PropTypes.oneOf([
  "auto-start",
  "auto",
  "auto-end",
  "top-start",
  "top",
  "top-end",
  "right-start",
  "right",
  "right-end",
  "bottom-end",
  "bottom",
  "bottom-start",
  "left-end",
  "left",
  "left-start"
]);
